import { useQuery } from '@tanstack/react-query';

import { type UUID } from '~/types/common';

import {
  useInitDlns,
  useInitPermittedUsers,
} from '~/models/deliveries/DeliveryNote/utils/hooks';

import { queryKeysDeliveryNote } from './queryKeys';
import { useQueryDeliveryNotesBulk } from './useQueryDeliveryNotesBulk';

export const useQueryPermittedUsers = (deliveryNoteIds: UUID[] = []) => {
  const initDlns = useInitDlns();

  const { data: deliveryNotes } = useQueryDeliveryNotesBulk(deliveryNoteIds);

  const {
    data: initializedAssets = [],
    isLoading: isLoadingInitDlns,
    isError: isErrorLoadingInitDlns,
  } = useQuery({
    enabled: Boolean(deliveryNotes?.assets),
    async queryFn() {
      if (!deliveryNotes?.assets) {
        return [];
      }

      return initDlns(deliveryNotes.assets);
    },
    queryKey: queryKeysDeliveryNote.initDls(deliveryNoteIds),
    refetchOnWindowFocus: false,
  });

  const {
    permittedUserIds,
    isLoading: isLoadingInitPermittedUsers,
    permittedUsers,
  } = useInitPermittedUsers({
    deliveryNotes: initializedAssets,
  });

  return {
    data: { permittedUserIds, permittedUsers },
    isLoading: isLoadingInitPermittedUsers || isLoadingInitDlns,
    isError: isErrorLoadingInitDlns,
  };
};
